module.exports = __webpack_public_path__ + "img/28667-002.6ade1a9e.jpg";